<template>
  <div class="contact">
    <div class="contact__content">
      <div class="contact__content--left">
        <div class="contact__content__header">
          <h1 class="large-title title">
            We’re here for you. Say hi.
          </h1>
        </div>
        <div class="contact__content__info">
          <span>
            It’s easy to reach us. And it’s free. Two things everyone loves.
            <br /><br />
            We’re ready to take your business to the next level.
            <br /><br />
            Feel free to reach out to any and all of us – we’re generally pretty friendly. Except when we are hungry.
          </span>
        </div>
      </div>
      <div class="contact__content--right">
        <div class="contact__content__form">
          <div class="contact__content__form__field">
            <adx-input :ref="dataRef.full_name" :label="`Full Name *`" :error.sync="fullNameError" :validation="['NotEmpty', 'MinLength:2', 'MaxLength:100']" :value.sync="full_name" />
          </div>
          <div class="contact__content__form__field">
            <adx-input :ref="dataRef.email" :label="`Email Address *`" :error.sync="emailError" :validation="['NotEmpty', 'Email']"  :value.sync="email" />
          </div>
          <div class="contact__content__form__fields">
            <adx-input :ref="dataRef.mobile" :label="`Phone Number *`" :error.sync="mobileError" :validation="['NotEmpty', 'Phone', 'Numeric', 'MinLength:7', 'MaxLength:15']" :value.sync="mobile" />
            <adx-input :label="`Company Name`" :value.sync="company" />
          </div>
          <div class="contact__content__form__field">
            <adx-dropdown :value.sync="subject" :type="true" :label="`Subject`" :options="defaultSubject" />
          </div>
          <div class="contact__content__form__field">
            <adx-textarea :ref="dataRef.message" :label="`Message *`" :error.sync="messageError" :validation="['NotEmpty', 'MinLength:5', 'MaxLength:200']" :value.sync="message" />
          </div>
        </div>
        <div class="contact__content__button">
          <button
            type="button"
            :class="['primary', 'btn-large', 'btn-checkout-large', isSaving ? 'disabled' : '']"
            @click="submit">
            Send Now
            <adx-loading-secondary v-if="isSaving" slot="loading" class="loading" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Input from '@/components/Form/Input'
import Dropdown from '@/components/Form/SelectDropdown'
import TextArea from '@/components/Form/TextArea'
import LoadingSpinner from '@/components/Loading/Secondary-white'

import api from '@/api'
import { apiV2 } from '@/api/urls'

export default {
  name: 'adx-contact-us',
  components: {
    'adx-input': Input,
    'adx-dropdown': Dropdown,
    'adx-textarea': TextArea,
    'adx-loading-secondary': LoadingSpinner
  },
  props: {

  },
  data() {
    return {
      dataRef: {
        full_name: 'full_name',
        email: 'email',
        mobile: 'mobile',
        message: 'message'
      },
      isSaving: false,
      full_name: '',
      email: '',
      mobile: '',
      company: '',
      subject: '',
      message: '',
      fullNameError: '',
      emailError: '',
      mobileError: '',
      messageError: '',
      defaultSubject: [
        {
          id: 0,
          label: `Customer Support`,
          value: `support`
        },
        {
          id: 1,
          label: `Partner Up Inquiry`,
          value: `partnerup`
        },
        {
          id: 2,
          label: `Billboard Inquiry`,
          value: `billboard`
        },
        {
          id: 3,
          label: `Cinema Inquiry`,
          value: `cinema`
        },
        {
          id: 4,
          label: `Digital Screen Inquiry`,
          value: `digitalscreen`
        },
        {
          id: 5,
          label: `Experience Inquiry`,
          value: `experience`
        },
        {
          id: 6,
          label: `InFlight Inquiry`,
          value: `inflight`
        },
        {
          id: 8,
          label: `Digital Advertising Inquiry`,
          value: `digital`
        },
        {
          id: 9,
          label: `Videotron Inquiry`,
          value: `videotron`
        }
      ]
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
    const { subject } = this.$route.query
    if (subject) {
      this.subject = subject
    } else {
      this.subject = this.defaultSubject[0].value
    }
  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    submit() {
      (async () => {
        this.isSaving = true
        let validation = this.validate_user_info()
        if (validation.isValid) {
          let subject = this.subject
          if (this.subject !== 'support') {
            subject = this.defaultSubject.filter(el => el.value === this.subject).pop().label
          }
          const body = {
            subject: subject,
            full_name: this.full_name,
            email: this.email,
            mobile: this.mobile,
            message: this.message,
            company_name: this.company,
            status: 'open'
          }
          const response = await api.post(apiV2.contactUs, body)
          if (response.status === 201) {
            this.$notify({
              group: 'saved',
              title: 'Success',
              text: `Data successfully saved!`,
              type: 'success'
            });
            this.reset()
          } else {
            this.$notify({
              group: 'saved',
              title: 'Error',
              text: response.statusText,
              type: 'danger'
            });
          }
        } else {
          this.raiseError(validation.id)
        }
        this.isSaving = false
      })();
    },
    validate_user_info() {
      let data = { isValid: true, id: null }
      let dataRef = this.dataRef

      for (let key in this.dataRef) {
        const value = this.$data[key]
        if (!value || this.inputInvalid(dataRef[key])) {
          data.isValid = false
          data.id = this.dataRef[key]
          break
        }
      }

      return data
    },
    raiseError(id) {
      let element = this.$refs[id].$el.firstElementChild
      element.focus()
      element.blur()
    },
    inputInvalid(value) {
      let error = false
      let dataRef = this.dataRef
      switch(value) {
        case dataRef.full_name:
          error = this.fullNameError
          break
        case dataRef.email:
          error = this.emailAddressError
          break
        case dataRef.mobile:
          error = this.mobileError
          break
        case dataRef.message:
          error = this.messageError
          break
      }

      return error
    },
    reset() {
      this.full_name = ''
      this.email = ''
      this.mobile = ''
      this.company = ''
      this.subject = ''
      this.message = ''
      this.fullNameError = ''
      this.emailError = ''
      this.mobileError = ''
      this.messageError = ''
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
<style lang='scss' scoped>
@import './index.scss';
</style>
<style lang='scss'>
.contact__content__form__field {
  .selectDropdown {
    .select {
      .standardInput {
        padding: 16px !important;
      }
    }
  }
}
</style>